const server = process.env.REACT_APP_API_URL || 'https://pladmin.sanako.com/api/v1';
//const server = process.env.REACT_APP_API_URL || 'https://pronouncelive.dev/api/v1';


export default server;



// WEBPACK FOOTER //
// ./src/config/index.js